module.exports = __webpack_public_path__ + "static/media/wind.b60b79f3.mp3";